import { Box, Typography, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';

interface SelectedPatientSummaryProps {
  nhsNumber: string;
  name: string;
  dob: Date;
  onClear: () => void;
}

const SelectedPatientSummary = ({ nhsNumber, name, dob, onClear }: SelectedPatientSummaryProps) => (
  <Box
    sx={{
      border: '1px solid #e0e0e0',
      borderRadius: 2,
      backgroundColor: (theme) => theme.palette.primary.neutral,
      mb: 2,
    }}>
    <Box display="flex" justifyContent="space-between" alignItems="center">
      <Box display="flex" alignItems="center">
        <Typography p={2} variant="body2" color="textSecondary">
          NHS number
        </Typography>
        <Typography variant="body1" fontWeight="medium" ml={4}>
          {nhsNumber}
        </Typography>
      </Box>
      <Box p={2} display="flex" alignItems="center">
        <Button startIcon={<CloseIcon />} onClick={onClear} color="error">
          CLEAR
        </Button>
      </Box>
    </Box>
    <Box borderTop="1px solid #e0e0e0" px={2} py={2}>
      {/* Each info row */}
      <Box display="flex" mb={1}>
        <Typography variant="body2" color="textSecondary" sx={{ width: 120 /* fixed label width for alignment */, flexShrink: 0 }}>
          Name
        </Typography>
        <Typography ml={3} variant="body1" fontWeight="bold">
          {name}
        </Typography>
      </Box>

      <Box display="flex">
        <Typography variant="body2" color="textSecondary" sx={{ width: 120, flexShrink: 0 }}>
          Date of birth
        </Typography>
        <Typography ml={3} variant="body1">
          {moment(dob).format('DD/MM/YYYY')}
        </Typography>
      </Box>
    </Box>
  </Box>
);

export default SelectedPatientSummary;
